import React from "react";

import AttributeTagPicker from "./Components/AttributeTagPicker";

import { UserLanguageAttributeSet } from "@/schemas/profile/attributes/UserLanguageAttributeSet";
import type { AttributeValue } from "@/schemas/attribute/AttributeSet";

type Props = {
  onSelectionChange: (selectedValues: AttributeValue[]) => void;
  selectedValues: AttributeValue[];
};

function Language({
  onSelectionChange,
  selectedValues,
}: Props): React.JSX.Element {
  // TODO: If we want to preselect a default language like English, we can do so here

  return (
    <AttributeTagPicker
      attributeSet={UserLanguageAttributeSet}
      onSelectionChange={onSelectionChange}
      selectedValues={selectedValues}
    />
  );
}

export default Language;
